import React from 'react';
import {
  Grid,
} from '@material-ui/core';
import clsx from 'clsx';

import MediaExportTabStyles from './styles';
import {
  DownloadVideoAction,
  DownloadVideoThumbnailAction,
} from './actions';

export const DownloadTab = () => {
  const classes = MediaExportTabStyles();

  return (
    <>
      <Grid
        container
        className={clsx(classes.row, classes.title)}
      >
        File Type
      </Grid>
      <Grid
        container
        className={classes.row}
        alignItems="center"
      >
        <Grid item>MP4 Video</Grid>
        <Grid item className={classes.actionContainer}>
          <DownloadVideoAction />
        </Grid>
      </Grid>
      <Grid
        container
        className={classes.row}
        alignItems="center"
      >
        <Grid item>Thumbnail</Grid>
        <Grid item className={classes.actionContainer}>
          <DownloadVideoThumbnailAction />
        </Grid>
      </Grid>
    </>
  );
};

export default DownloadTab;
